import { Page } from "@/models/page-models/Page";

export const Machines: Page = {
  "path": "machines",
  "name": "Machines",
  "props": {
    "data": {
      "title": "Machines",
      "printable": "FALSE",
      "url": "machines",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Add New Machine",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "openAddMachine"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Machines",
                  "disabled": "FALSE",
                  "items": "fetchedData.machines.data.docs",
                  "headers": [
                    {
                      "value": "__item._id",
                      "text": "Machine #",
                      "type": "url",
                      "url": "machine/{{__item._id}}"
                    },
                    {
                      "value": "__item.name",
                      "text": "Name"
                    },
                    {
                      "value": "__item.isContinuous",
                      "text": "Continuous"
                    },
                    {
                      "value": "__item.mechanicalSpeed",
                      "text": "Speed"
                    },
                    {
                      "value": "__item.possibleProcesses",
                      "text": "Possible Processes",
                      "formula": "fn(HELPER_FN,joinArray,{{__item.possibleProcesses}})"
                    },
                    {
                      "value": "__item.actions",
                      "text": "Actions",
                      "type": "actions",
                      "width": 150,
                      "actions": [
                        {
                          "label": "Remove Machine",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copySelectedMachineId"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openDeleteMachinePopup"
                            }
                          ]
                        }
                      ],
                      "useMenu": false
                    }
                  ],
                  "tableType": "static",
                  "showActions": true,
                  "pagination": {
                    "pageVariable": "fetchedData.machineSearch.page",
                    "serverItemsLengthVariable": "fetchedData.machines.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 2,
                        "pageFunction": {
                          "name": "getMachines",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v1/machines/get",
                          "arg2Key": "storeInVar",
                          "arg2Value": "fetchedData.machines",
                          "arg3Key": "postData",
                          "arg3Value": "fetchedData.machineSearch"
                        },
                        "name": "getMachines"
                      }
                    ]
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "popupGroup",
          "label": "Delete Machine",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "formData.confirmMessage",
                  "label": "All processes depending on the machine will fail. Do you want to continue"
                }
              ]
            }
          ],
          "width": "500",
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "removeMachine"
                },
                {
                  "executionOrder": 2,
                  "name": "closeDeleteMachinePopup"
                }
              ]
            }
          ]
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultMachineFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultMachineFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.machineSearch"
        },
        "name": "copyDefaultMachineFilters"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMachines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/machines/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.machines",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.machineSearch"
        },
        "name": "getMachines"
      }
    ],
    "functions": [
      {
        "name": "copySelectedMachineId",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item._id",
        "arg2Key": "destinationKey",
        "arg2Value": "formData.selectedMachineId"
      },
      {
        "name": "openDeleteMachinePopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Delete Machine"
      },
      {
        "name": "closeDeleteMachinePopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Delete Machine"
      },
      {
        "name": "removeMachine",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/machine/{{formData.selectedMachineId}}/remove",
        "arg2Key": "refreshPage",
        "arg2Value": "TRUE"
      },
      {
        "name": "openAddMachine",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "machine/new"
      },
      {
        "name": "getDefaultMachineFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 20,
          "paginate": true
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER",
  "visible": true
}